import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store";
import routes from "./routes"
// import { getCookie, setCookie } from "../utils/cookie-utils"

Vue.use(VueRouter)

const router = new VueRouter({
	mode: process.env.NODE_ENV == "production" ? "history" : "hash",
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to) {
		if (to.hash) {
			const element = document.querySelector(to.hash);
			if (element) {
				return window.scrollTo({ top: element.offsetTop, behavior: 'smooth' });
			}
		}
		return window.scrollTo({ top: 0, behavior: 'smooth' });
	}
})

router.beforeEach((to, from, next) => {
	store.dispatch("setLoading", true);
	next();
});

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
	//
});

router.beforeResolve((to, from, next) => {
	// if(to.name == 'about'){
	// 	if(to.params.password == "password") {
	// 		setCookie("enabled", true, 30);
	// 		next({ name: "home" });
	// 	} else {
	// 		next();
	// 	}
	// } else {
	// 	if(getCookie("enabled")) {
	// 		next();
	// 	} else {
	// 		next({ name: "about" });
	// 	}
	// }
	next();
});

export default router
